import React, { useEffect, useState } from 'react';

import { connect } from 'react-redux';
import { AnyAction } from 'redux';
import { ThunkDispatch } from 'redux-thunk';

import { loadOrg } from '../../organization/actions/load-org';
import { orgSelector } from '../../reducers/org-selectors';

import { VCardDialog } from './v-card-dialog';

const mapStateToProps = (state: any, { orgId }: InputProps) => ({
  org: orgId ? orgSelector(state, orgId) : null,
});

const mapDispatchToProps = (
  dispatch: ThunkDispatch<any, any, AnyAction>,
  { orgId }: InputProps,
) => ({
  actions: {
    loadOrg: () => (orgId ? dispatch(loadOrg(orgId)) : null),
  },
});

type InputProps = {
  orgId?: number;
  isScheduledMessage?: boolean;
};
type ReduxProps = ReturnType<typeof mapStateToProps>;
type DispatchProps = ReturnType<typeof mapDispatchToProps>;
type Props = InputProps & ReduxProps & DispatchProps;

export const VCardMessage = connect(
  mapStateToProps,
  mapDispatchToProps,
)(({ orgId, org, isScheduledMessage, actions }: Props) => {
  const [displayVCardDialog, setDisplayVCardDialog] = useState<boolean>(false);
  const handleDisplayVCardDialog = () => setDisplayVCardDialog(!displayVCardDialog);

  useEffect(() => {
    actions.loadOrg();
  });

  const NoDialogMessage = () => (
    <div className="typo-subtitle u-margin-bottom">
      Employee(s) {isScheduledMessage ? 'will receive' : 'received'} your contact card with this
      message
    </div>
  );

  if (!orgId) {
    return <NoDialogMessage />;
  }

  return org && org.phoneNumber ? (
    <div className="typo-subtitle u-margin-bottom">
      Employee(s) {isScheduledMessage ? 'will receive ' : 'received '}
      <span role="presentation" onClick={handleDisplayVCardDialog} className="typo-link ">
        your contact card
      </span>{' '}
      with this message
      {displayVCardDialog && (
        <VCardDialog
          handleToggleDialog={handleDisplayVCardDialog}
          name={org.name}
          phone={org.phoneNumber}
          logo_path={org.logo_path}
          org_key={org.org_key}
        />
      )}
    </div>
  ) : (
    <NoDialogMessage />
  );
});
